import React from "react";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import { Divider } from "@material-ui/core";


const useStyles = makeStyles(()=>({
    paper:{
        borderRadius: 0,
        backgroundColor: "#ED2024",
        color: "#FFF",
    },
    list: {
        paddingTop: 0,
        paddingBottom: 0
    },
    listItem: {
        fontSize: ".8em"
    },
    divider:{
        backgroundColor: "#fff",
        opacity: ".5",
    },
    button:{
        "&:hover": {
            backgroundColor: "#800000"
          }
    }

}))


const linkData = [
    { 
      url: "https://brpioneer.accenture.com/originacao-auto/proposal/step-personal",
      text: "SantanderAuto"
    }
]

function SegurosSubMenu(props){
    const {anchor, open, handleClose} = props;
    const classes = useStyles()

    return (
        <Popper id="popper" open={open} anchorEl={anchor.current} role={undefined} transition disablePortal placement={"bottom"}  >
          {({ TransitionProps}) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: 'left top', left:"5px"}}
            >
              <Paper elevation={0} classes={{root: classes.paper}}>
                <ClickAwayListener onClickAway={()=>handleClose(false)}>
                  <MenuList autoFocusItem={open} id="menu-list-grow" classes={{root: classes.list}}>
                    {linkData.map((e, i, a)=>
                    [<MenuItem key={e.text} ListItemClasses={{button: classes.button}} component="a" href={e.url} target="_blank" classes={{root: classes.listItem}} >
                        {e.text}
                        </MenuItem>,
                    i < a.length-1 && <Divider key={"divider-"+i} classes={{root: classes.divider}}  component="li" />
                    ]
                    
                    )}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>

    )
}

export { SegurosSubMenu }